import { render, staticRenderFns } from "./stepThree.vue?vue&type=template&id=6a4cff0d&scoped=true&"
import script from "./stepThree.vue?vue&type=script&lang=js&"
export * from "./stepThree.vue?vue&type=script&lang=js&"
import style0 from "./stepThree.vue?vue&type=style&index=0&id=6a4cff0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4cff0d",
  null
  
)

export default component.exports